import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterArray'
})
export class FilterPipe implements PipeTransform {

  transform<T, K extends keyof T>(array: T[], key: K, value: T[K]): T[] {
    if (!array || !array.length) {
      return null;
    }
    return array.filter(x => x[key] === value);
  }

}
